import { FC, ReactElement } from 'react';

import { ConditionalWrapperProps } from './types';

export const ConditionalWrapper: FC<ConditionalWrapperProps> = ({ condition, wrapper, children }) => {
  return (condition ? wrapper(children) : children) as ReactElement<any>;
};
